import { getSourceEventParams, useAmplitude } from '@crehana/analytics';
import { useTranslation } from '@crehana/i18n';
import { CustomNextImage as Image } from '@crehana/next';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { PrimaryButton } from '@crehana/ui';
import { customSessionStorage } from '@crehana/utils';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled from 'styled-components';

import { AMPLITUDE_TRACKS } from '@/views/B2BLanding/events';

const CHAT_PHOTO =
  'https://crehana-public-catalog.imgix.net/images/app/gallery/2022/04/07/8f198ff5/fd933f30.png';

const ImageWrapper = styled.div`
  border: 4px solid ${({ theme }) => theme.colors.primary.main};
  width: 96px;
  height: 96px;
`;

const StepCompleted = () => {
  const { logEvent } = useAmplitude();
  const { t } = useTranslation();
  const downloadUrlB2B = customSessionStorage.getItem('downloadUrlB2B');
  const downloadUrlB2C = customSessionStorage.getItem('downloadUrlB2C');
  const { Source, 'Source Detail': sourceDetail } = getSourceEventParams();

  const canDownload = Boolean(downloadUrlB2B) || Boolean(downloadUrlB2C);
  const stepTitleKey = canDownload
    ? 'SUCCESS_DIALOG_TITLE_DOWNLOADABLE'
    : 'STEP_COMPLETED_TITLE';
  const ctaKey = canDownload
    ? 'SUCCESS_DIALOG_CTA_DOWNLOADABLE'
    : 'STEP_COMPLETED_CTA_LABEL';

  const onDownload = () => {
    if (downloadUrlB2B) {
      logEvent({
        event: AMPLITUDE_TRACKS.DOWNLOADED_RESOURCE,
        data: {
          Source,
          'Source Detail': sourceDetail,
          Category: sourceDetail,
        },
      });
      customSessionStorage.removeItem('downloadUrlB2B');
      // Info: logEvent callback is not used because it is failing
      window.open(downloadUrlB2B);
    } else if (downloadUrlB2C) {
      logEvent({
        event: 'Download Resource',
        data: {
          ...getSourceEventParams(),
          'Resource name': sourceDetail,
          source: 'Resource Detail Page',
        },
      });
      customSessionStorage.removeItem('downloadUrlB2C');
      // Info: logEvent callback is not used because it is failing
      window.open(`${downloadUrlB2C}?platform=direct`);
    }

    window.location.href = '/';
  };

  return (
    <section
      className="text-white w-full flex flex-col items-center justify-center mx-auto mt-160"
      style={{ maxWidth: 750 }}
    >
      <ImageWrapper className="rounded-full relative overflow-hidden mx-auto mb-24 sm:mb-32 md:mb-80">
        <Image
          src={CHAT_PHOTO}
          alt="consultant"
          layout="fill"
          objectFit="cover"
          objectPosition="center"
          quality={100}
        />
      </ImageWrapper>
      <h1 className="tw-font-pop text-24 leading-28 sm:text-32 sm:leading-40 md:text-40 md:leading-48 tw-font-semibold mb-16 md:mb-24 text-center">
        {t(stepTitleKey)}
      </h1>
      <p className="tw-font-pop font-normal text-24 leading-24 sm:text-24 sm:leading-28 md:text-32 md:leading-40 text-center mb-16 sm:mb-32">
        {t('STEP_COMPLETED_SUB_TITLE')}
      </p>
      <PrimaryButton label={t(ctaKey)} size="l" isDark onClick={onDownload} />
    </section>
  );
};

export default StepCompleted;
